import { DialogClearStylesButtonsFooter } from 'components/accounts/DialogClearStyles';
import FontIcon from 'components/icons/FontIcon';
import { PrimaryButton, SecondaryButton, TextButton } from 'components/v2/buttons';
import CompilerSelectControlledComponent from 'components/v2/epd-compiler-inputs/CompilerSelectControlledComponent';
import { HelpBox } from 'components/v2/help-boxes';
import { Dialog } from 'primereact/dialog';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { EpdLinks } from 'routes/EpdRoutes';
import styled from 'styled-components';
import { VersionHistoryModel } from 'types/epd-definition/VersionHistoryModel';

const VersionComparerDialog: React.FunctionComponent<{
  epdId: string;
  currentVersionId: string;
  versions: VersionHistoryModel[];
}> = ({ epdId, currentVersionId, versions }) => {
  const history = useHistory();
  const [isOpened, setIsOpened] = useState(false);
  const [referenceVersion, setReferenceVersion] = useState<string | undefined>(currentVersionId);
  const [versionToCompareWith, setVersionToCompareWith] = useState<string | undefined>();
  const versionsLookup = versions.map((x) => {
    return { label: x.fullIdentificationNumber, value: x.id };
  });

  const handleCompareButtonClick = () => {
    const url = EpdLinks.epdVersionCompare(epdId, versionToCompareWith!, referenceVersion!);
    history.push(url);
  };

  return (
    <>
      <TextButton
        type="button"
        text
        label="Version comparison"
        icon={<FontIcon icon="compare" style={{ fontSize: '12px', marginRight: '5px' }} />}
        onClick={() => setIsOpened(true)}
      />
      <Dialog
        header="Version comparison"
        visible={isOpened}
        style={{ width: 560, overflow: 'visible' }}
        contentStyle={{ overflow: 'visible' }}
        onHide={() => setIsOpened(false)}
        closable={false}
      >
        <DialogContentContainer>
          <HelpBox>Please choose the versions you want to compare.</HelpBox>
          <div style={{ gap: 30, display: 'grid' }}>
            <CompilerSelectControlledComponent
              label="Reference version"
              name="referenceVersion"
              options={versionsLookup}
              value={versionsLookup.optionByValue(referenceVersion) ?? null}
              onChanged={(_: any, value: any) => {
                setReferenceVersion(value);
              }}
              placeholder="Select version"
              isClearable={false}
              required
              overrideReadOnlyMode
              maxMenuHeight={5 * 38}
            />
            <CompilerSelectControlledComponent
              label="Version to compare with"
              name="referenceVersion"
              options={versionsLookup}
              value={versionsLookup.optionByValue(versionToCompareWith) ?? null}
              onChanged={(_: any, value: any) => {
                setVersionToCompareWith(value);
              }}
              placeholder="Select version"
              isClearable={false}
              required
              overrideReadOnlyMode
              maxMenuHeight={5 * 38}
            />
          </div>
        </DialogContentContainer>
        <div style={{ marginTop: '40px', paddingBottom: '40px' }}>
          <DialogClearStylesButtonsFooter>
            <SecondaryButton type="button" label="Cancel" onClick={() => setIsOpened(false)} />
            <PrimaryButton
              type="submit"
              label="Compare"
              onClick={handleCompareButtonClick}
              disabled={!referenceVersion || !versionToCompareWith || referenceVersion === versionToCompareWith}
            />
          </DialogClearStylesButtonsFooter>
        </div>
      </Dialog>
    </>
  );
};

const DialogContentContainer = styled.div`
  padding: 0.25rem 2rem 0rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export default VersionComparerDialog;
